import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { color, space, shadow, typography, variant } from 'styled-system'

const ButtonBase = styled.button`
  ${color}
  ${space}
  ${shadow}
  ${typography}

  cursor: pointer;
  text-align: center;
  border: none;
  background: transparent;
  width: ${props => props.width};
  :disabled, :disabled:hover {
    color: ${props => props.theme.colors.grays.N300};
    cursor: not-allowed;
  }
`
ButtonBase.defaultProps = {
  fontFamily: 'body',
  fontSize: '14px',
  fontWeight: 'bold',
}

const TextButton = styled(ButtonBase)(
  {
    width: `${props => props.width}`,
  },
  variant({
    variants: {
      primary: {
        color: () => 'primary',

        '&:hover': {
          color: () => 'turquoises.T600',
        },
      },

      secondary: {
        color: () => 'secondary',

        '&:hover': {
          color: () => 'blues.A900',
        },
      },

      tertiary: {
        color: () => 'oranges.L400',

        '&:hover': {
          color: () => 'oranges.L500',
        },
      },
    },
  }),
)

TextButton.defaultProps = {
  variant: 'primary',
}

TextButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'custom']),
}

export default TextButton
